import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import { IconButton, Tooltip, Typography } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { format } from 'date-fns';

import { StatusChip } from '@/components/Cards/Chips/StatusChip';

import { statusStyle, statusStyleBG, statusTranslation } from './dependencies/constants';

const formatDate = (date: Date | null) => (date ? format(date, 'dd-MM-yyyy') : null);

export const reportsColumns = (): Array<GridColDef> => [
  {
    field: 'createdAt',
    flex: 1,
    headerName: `Fecha de creación`,
    width: 200,
    align: 'center',
    sortable: false,
    headerAlign: 'center',
    renderCell: (params) => (
      <Typography variant="body2" display={'inline'} sx={{ fontWeight: 'bold' }}>
        {formatDate(new Date(params.row.createdAt))}
      </Typography>
    ),
  },
  {
    field: 'notes',
    flex: 1,
    headerName: 'Descripción',
    align: 'center',
    sortable: false,
    headerAlign: 'center',
    renderCell: (params) => (
      <Typography
        variant="body2"
        sx={{ display: 'inline', color: (theme) => theme.palette.grey[600] }}
      >
        {params.row.notes}
      </Typography>
    ),
  },
  {
    field: 'betweenDates',
    flex: 1,
    headerName: 'Periodo de reporte',
    align: 'center',
    sortable: false,
    headerAlign: 'center',
    renderCell: (params) => (
      <>
        <Typography
          variant="body2"
          sx={{ textAlign: 'center', color: (theme) => theme.palette.grey[600] }}
          mt={2.5}
        >
          <strong>Desde:</strong> {formatDate(new Date(params.row.betweenDates.startDate))} <br />{' '}
          <br />
          <strong>Hasta:</strong> {formatDate(new Date(params.row.betweenDates.endDate))}
        </Typography>
      </>
    ),
  },

  {
    field: 'status',
    flex: 0.5,
    headerName: 'Estatus',
    align: 'center',
    sortable: false,
    headerAlign: 'center',
    renderCell: (params) => (
      <StatusChip
        status={statusTranslation[params.row.status]}
        color={statusStyle[params.row.status]}
        bg={statusStyleBG[params.row.status]}
      />
    ),
  },
  {
    field: 'actions',
    flex: 0.5,
    headerName: 'Acciones',
    align: 'center',
    sortable: false,
    headerAlign: 'center',
    resizable: false,
    renderCell: (params) => {
      return (
        <>
          {params.row.status === 'PROCESSED' && (
            <Tooltip followCursor title="Descarga de reporte" placement="top">
              <IconButton color="primary" onClick={() => window.open(params.row.url, '_blank')}>
                <CloudDownloadOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}
        </>
      );
    },
  },
];
